import { gql, QueryResult, QueryTuple, useLazyQuery, useQuery } from '@apollo/client';

import { getPolices } from '../../../../utils/gqlPolicesUtil';

export const IS_MFA_ENABLED_BY_EMAIL = gql`
  query IsMFAEnabledByEmail {
    isMFAEnabledByEmail {
      enabled
    }
  }
`;

export interface IIsMFAEnabledByEmailResponse {
  isMFAEnabledByEmail: {
    enabled: boolean;
  };
}

export type IsMFAEnabledByEmailVariables = Record<string, never>;

export const useLazyIsMFAEnabledByEmail = (
  fromCache?: boolean,
): QueryTuple<IIsMFAEnabledByEmailResponse, IsMFAEnabledByEmailVariables> =>
  useLazyQuery<IIsMFAEnabledByEmailResponse, IsMFAEnabledByEmailVariables>(IS_MFA_ENABLED_BY_EMAIL, {
    ...getPolices(fromCache),
  });

export interface IUseQueryIsMFAEnabledByEmailOptions {
  skip?: boolean;
}

export const useQueryIsMFAEnabledByEmail = (
  fromCache?: boolean,
  options?: IUseQueryIsMFAEnabledByEmailOptions,
): QueryResult<IIsMFAEnabledByEmailResponse, IsMFAEnabledByEmailVariables> =>
  useQuery<IIsMFAEnabledByEmailResponse, IsMFAEnabledByEmailVariables>(IS_MFA_ENABLED_BY_EMAIL, {
    ...getPolices(fromCache),
    skip: options?.skip === true,
  });
